import { Focus, Maximize2, Minimize2, Scan, ZoomIn, ZoomOut } from 'lucide-react';
import { FloatingPanel, StageButton } from './FloatingPanel';

/**
 * Camera housekeeping, bottom-right as in the workbench.
 *
 * "Centre on crowns" is the one that matters: a dentist who has panned and
 * zoomed until they are lost needs one click back to the thing they came to
 * judge, not back to the whole arch.
 */
interface NavPadProps {
  onZoomIn: () => void;
  onZoomOut: () => void;
  onFrameCrowns: () => void;
  onFrameAll?: () => void;
  fullscreen: boolean;
  onFullscreen: () => void;
  vertical?: boolean;
}

export function NavPad({
  onZoomIn,
  onZoomOut,
  onFrameCrowns,
  onFrameAll,
  fullscreen,
  onFullscreen,
  vertical = true,
}: NavPadProps) {
  const side = vertical ? 'left' : 'top';
  return (
    <FloatingPanel
      role="toolbar"
      aria-label="Camera"
      className={vertical ? 'flex flex-col gap-0.5 p-1' : 'flex items-center gap-0.5 p-1'}
    >
      <StageButton label="Zoom in" side={side} onClick={onZoomIn}>
        <ZoomIn />
      </StageButton>
      <StageButton label="Zoom out" side={side} onClick={onZoomOut}>
        <ZoomOut />
      </StageButton>
      <StageButton label="Centre on crowns" shortcut="F" side={side} onClick={onFrameCrowns}>
        <Focus />
      </StageButton>
      {onFrameAll && (
        <StageButton label="Show everything" side={side} onClick={onFrameAll}>
          <Scan />
        </StageButton>
      )}
      <StageButton
        label={fullscreen ? 'Exit full screen' : 'Full screen'}
        side={side}
        onClick={onFullscreen}
      >
        {fullscreen ? <Minimize2 /> : <Maximize2 />}
      </StageButton>
    </FloatingPanel>
  );
}
